import axios from 'axios';

const config = window.astConfig || {};

const client = axios.create({
    baseURL: config.apiUrl || '/wp-json/ast/v1',
    headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': config.nonce || '',
    },
});

// Add locale to every request if set.
client.interceptors.request.use((req) => {
    const locale = config.locale || 'nl';
    if (req.method === 'get') {
        req.params = { ...req.params, locale: locale + '_' + locale.toUpperCase() };
    }
    return req;
});

export default client;
